import { Card, Flex, Text } from '@chakra-ui/react';
import { FC } from 'react';

interface INumeratedCardProps {
  number: number;
  label: string;
  description: string;
}

export const NumeratedCard: FC<INumeratedCardProps> = ({ number, label, description }) => {
  return (
    <Card
      w={{ base: '336px', lg: '380px' }}
      h="122px"
      p={3}
      borderRadius={8}
      flexDirection="row"
      fontSize="lg"
      alignItems="flex-start"
    >
      <Flex
        color="violet.500"
        fontWeight="bold"
        mr={4}
        flexShrink={0}
        bgColor="violet.50"
        justifyContent="center"
        alignItems="center"
        width={10}
        h={10}
        borderRadius={8}
      >
        {number}
      </Flex>
      <Flex textAlign="left" flexDirection="column">
        <Text fontSize="md" fontFamily="heading" fontWeight="bold">
          {label}
        </Text>
        <Text mt={2} fontSize="md">
          {description}
        </Text>
      </Flex>
    </Card>
  );
};
